import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_icon_change",
  "use": "icon-home_icon_change-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-home_icon_change\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M12.243 3.757A6 6 0 1 0 14 8\" stroke=\"#818999\" stroke-width=\"1.2\" stroke-linecap=\"round\" /><path fill=\"#818999\" d=\"m14.522 4.82-4.714.164 2.5-4.33z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol